import React from 'react';
import NavigationComponent from '../../commonComponents/util/NavigationComponent';
import PaginatedTable from '../../commonComponents/util/PaginatedTable';
import RecipientAccountsTableRow from './RecipientAccountsTableRow';
import ConfirmationModal from '../../commonComponents/shared/ConfirmationModal';
import { isEmptyObj } from '../../../lib/utils';

export default class RecipientAccountsTable extends NavigationComponent {
    constructor(props) {
        super(props);

        this.state = this.initialState;

        this.getTableRow = this.getTableRow.bind(this);
    }

    initialState = {
        selectedRecord: {},
        showModals: {
            confirmationModal: false
        }
    };

    getTableRow(recipient) {
        return <RecipientAccountsTableRow key={recipient.applicantId} recipient={recipient}
            selectRecipient={this.props.selectRecipient}
            selected={this.props.selected.map(rec => rec.applicantId).indexOf(recipient.applicantId) >= 0}
            canSelect={this.props.selected.length < 2}
            canDelete={this.props.canDelete}
            canViewApplications={this.props.canViewApplications}
            includeTeudatZahut={this.props.data.records.some(d => !!d.teudatZahut)}
            delete={() => {
                this.setState({ selectedRecord: recipient }, this.toggleModal.bind(this, "confirmationModal"));
            }} />;
    }

    render() {
        const includeTeudatZahut = this.props.data.records.some(d => !!d.teudatZahut);
        let columns = [ 
            { title: '', sortable: false, id: 'select' },
            { title: 'First Name', sortable: true, id: 'firstName' },
            { title: 'Last / Org Name', sortable: true, id: 'lastOrOrgName' },
            { title: 'Address', sortable: true, id: 'address' },
            { title: 'Teudat Zahut', sortable: true, id: 'teudatZahut', hidden: !includeTeudatZahut },
            { title: 'Category', sortable: true, id: 'tag' },
            { title: 'Last Application', sortable: true, id: 'lastApplication', defaultDirection: 'Descending' },
            { title: 'Total', sortable: true, id: 'total', className: 'text-right' }
        ];
        if (this.props.canDelete) columns.push(
            { title: '', sortable: false, id: 'delete' }
        );

        return <div>
            <PaginatedTable
                name="recipients"
                page={this.props.page}
                totalCount={this.props.data.totalCount}
                resultsView={this.props.resultsView}
                sort={this.props.sort}
                loading={this.props.loading}
                success={this.props.success}
                renderRow={this.getTableRow}
                columns={columns}
                records={this.props.data.records || []}
                sortData={this.props.updateTable}
                changeDataView={this.props.updateTable}
                loadData={this.props.getRecipients} 
                noReload={true} />

            <ConfirmationModal
                show={this.state.showModals.confirmationModal}
                message={this.state.selectedRecord.applicantId
                    ? `Are you sure you want to permanently delete the account of ${this.state.selectedRecord.name || 'this recipient'}?` : ''}
                close={() => {
                    this.setState({ selectedRecord: this.initialState.selectedRecord });
                    this.toggleModal("confirmationModal");
                }}
                confirm={() => this.props.deleteRecipient(this.state.selectedRecord.applicantId)}
                loading={this.props.removing.loading}
                success={this.props.removing.success}
                errorMessage={this.props.removing.message} />
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/components/recipientAccountsComponents/recipientAccounts/RecipientAccountsTable.jsx